import { Route } from '~/routes/types';
import { TAGS_ROUTE } from '~/routes/private/tags/constants';
import Tags from '~/pages/tags';

export const tags: Route = {
  to: TAGS_ROUTE,
  exact: true,
  component: Tags
};
